import { render, staticRenderFns } from "./Livestreams.vue?vue&type=template&id=0ebc5408&scoped=true"
import script from "./Livestreams.vue?vue&type=script&lang=js"
export * from "./Livestreams.vue?vue&type=script&lang=js"
import style0 from "./Livestreams.vue?vue&type=style&index=0&id=0ebc5408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc5408",
  null
  
)

export default component.exports